import { DriverVehicleOverview } from "./vehicle/driverVehicleOverview";

export const Home = () => <DriverVehicleOverview />;
